<template>
  <div>
    <BaseFrame>
      <div slot="content" class="con">
        <div class="cardInfoCon">
          <div v-for="(item, index) in organizationInfo" :key="index" class="everyInfo">
            {{
              `${item.title} : ${
                organizationObj[item.key] ? organizationObj[item.key] : ""
              }`
            }}
          </div>
        </div>
      </div>
    </BaseFrame>
  </div>
</template>
<script>
import utils from "../../libs/utils";
import BaseFrame from "../../components/frame/BaseFrame.vue";
import healthInsManage from "../../services/healthInsManage";

export default {
  name: "medInsituteSearch",
  components: { BaseFrame },
  data() {
    return {
      organizationInfo: [
        {
          title: "定点医药机构编号",
          key: "fixmedinsCode",
        },
        {
          title: "定点医药机构名称",
          key: "fixmedinsName",
        },
        {
          title: "统一社会信用代码",
          key: "uscc",
        },
        {
          title: "定点医疗服务机构类型",
          key: "fixMedinsTypeName",
        },
        {
          title: "医院等级",
          key: "hospLvName",
        },
      ],
      organizationObj: {}
    };
  },
  mounted() {
    healthInsManage.getMedOrgInfos().then((res) => {
      if (res.data.status !== 200) {
        this.$Message.error(res.data.error);
        return
      }
      this.organizationObj = res.data.data;
    }).catch((err) => {
      utils.handleError(err)
    })
  },
};
</script>
<style lang="less" scoped>
.con {
  width: 98%;
  background-color: #ffffff;
  padding: 50px;
  .everyInfo {
    width: 32%;
    display: inline-block;
    margin-top: 10px;
  }
}
</style>